import styled from 'styled-components';

export const StoryContainer = styled.div` 
    display: flex; 
    align-items: center; 
    justify-content: center; 
    position: relative; 
    width: 55%; 
    height: 85vh; 
`